import { List, Popover } from 'antd';
import { memo, useEffect, useState } from 'react';

import { Avatar } from '@app/components/Avatar';
import { useWindowSize } from '@app/hooks';
import { generateKey } from '@app/utils';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const EmployeeContainer: NWorkSchedule.EmployeeContainer = memo(
  ({ item, photosAndMiddleNames, breakpoint, style }) => {
    const [open, setOpen] = useState(false);
    const hide = () => {
      setOpen(false);
    };
    const handleOpenChange = (newOpen: boolean) => setOpen(newOpen);

    useEffect(() => {
      const scrollHandler = () => hide();
      const container = document.querySelector('.records.table');
      if (container) {
        container.addEventListener('scroll', scrollHandler);
        return () => container.removeEventListener('scroll', scrollHandler);
      }
    }, [open]);

    const { innerWidth } = useWindowSize();
    const customAvatar =
      photosAndMiddleNames?.find(({ id }) => id === item.id)?.photo || null;

    const avatarContent = (
      customAvatar: string | null,
      item: NWorkSchedule.EmployeeContainerData
    ) => (
      <Avatar
        src={customAvatar}
        nameFirst={item.fullName}
        className="image"
        size={45}
      />
    );

    return (
      <Popover
        overlayClassName="tip-by-employee"
        placement="right"
        title={item.fullName}
        content={item.position || 'Без должности'}
        open={open}
        onOpenChange={handleOpenChange}
        trigger={innerWidth <= breakpoint ? 'click' : 'hover'}
        mouseEnterDelay={0.3}
      >
        <List.Item
          className="employee-container"
          key={generateKey('WorkSchedule', 'employee-li', item.id)}
          style={style}
        >
          <List.Item.Meta
            avatar={avatarContent(customAvatar, item)}
            title={item.curtailedFullName}
            description={item.curtailedPosition || 'Без должности'}
          />
        </List.Item>
      </Popover>
    );
  }
);
